"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLoader = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var ContentLoader_1 = require("../ContentLoader");
var FlexView_1 = require("../FlexView");
var Spacer_1 = require("../Spacer");
require("./widgetLoader.css");
var WidgetLoader = /** @class */ (function (_super) {
    __extends(WidgetLoader, _super);
    function WidgetLoader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.generateArray = function (length) { return Array(length).fill(''); };
        _this.renderBadgeListLoader = function (items) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "widget-loader-component" }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, md: 9, lg: 12 }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ hAlignContent: "center", gutters: { b: 'std' } }, { children: _this.generateArray(items).map(function (_, i) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsxs)(ContentLoader_1.ContentLoader, { children: [(0, jsx_runtime_1.jsx)("div", { className: "widget-loader_badge-list item" }), (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_badge-list badge" })] }) }), "widget-loader-list-item-".concat(i))); }) })) })) }))); };
        _this.renderListLoader = function (items) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "widget-loader-component" }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ hAlignContent: "evenly" }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, md: 8 }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ gutters: { b: 'std' } }, { children: _this.generateArray(items).map(function (_, i) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(ContentLoader_1.ContentLoader, { children: (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_list_item" }) }) }), "widget-loader-item-".concat(i))); }) })) })) })) }))); };
        _this.renderBoxes = function (config) {
            return _this.generateArray(config.contentPlaceholders).map(function (_, i) { return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView.Item, __assign({ xs: 12, lg: config.direction === 'vertical' ? 12 : 4 }, { children: [(0, jsx_runtime_1.jsx)(ContentLoader_1.ContentLoader, { children: (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_body_box1" }) }), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.4 }), (0, jsx_runtime_1.jsx)(ContentLoader_1.ContentLoader, { children: (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_body_box2" }) }), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.4 }), (0, jsx_runtime_1.jsx)(ContentLoader_1.ContentLoader, { children: (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_body_box3" }) })] })) }, "widget-loader-box-".concat(i))); });
        };
        _this.renderWidgetLoader = function (config) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('widget-loader', "widget-loader-".concat(config.direction)) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "widget-loader_header" }, { children: [(0, jsx_runtime_1.jsx)(ContentLoader_1.ContentLoader, { children: (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_header_title" }) }), (0, jsx_runtime_1.jsx)(ContentLoader_1.ContentLoader, __assign({ horizontalPosition: "end" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "widget-loader_header_badge" }) }))] })), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 1 }), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ className: "widget-loader_body_box-holder", flowDirection: { xs: 'column', lg: config.direction === 'horizontal' ? 'row' : 'column' }, hAlignContent: "between", gutters: { b: { xs: 'md' }, r: { lg: 'md' } } }, { children: _this.renderBoxes(config) }))] }))); };
        _this.renderLoader = function () {
            switch (_this.props.type) {
                case 'bagde-list':
                    return _this.renderBadgeListLoader(_this.props.items);
                case 'list':
                    return _this.renderListLoader(_this.props.items);
                case 'widget':
                    return _this.renderWidgetLoader(_this.props);
            }
        };
        return _this;
    }
    WidgetLoader.prototype.render = function () {
        return this.renderLoader();
    };
    return WidgetLoader;
}(React.PureComponent));
exports.WidgetLoader = WidgetLoader;
//# sourceMappingURL=WidgetLoader.js.map